import * as React from 'react';
import TextField from 'material-ui/TextField';

const zoom = {zoom: 1.2}
const renderTextField = ({ input, label, placeholder,  meta: { touched, error }, style={}, ...custom }) => (
    <TextField hintText={placeholder}
               floatingLabelText={label}
               errorText={touched && error}
							 style={{...style, ...zoom}}
               {...input}
               {...custom}
    />
);

export default renderTextField;



// WEBPACK FOOTER //
// ./src/app/components/fields/TextField.tsx